import { useQuery } from 'react-query';

import { BaseModel } from './api/types';
import { fetchWarehouses } from './api/warehouses';

export const useWarehouses = () => {
    return useQuery<BaseModel[], Error>(['Warehouses'], async () => await fetchWarehouses());
};
